import useApi, { Api, Model, Query } from "../common/hooks/useApi"

export interface UnidadProduccion extends Model {
    Nombre: string

}


export default () => {
    const api = useApi({ module: "UnidadProduccion" });

    return {
        list: (query: Query) => api.list!<UnidadProduccion>(query),
        save: (data: Partial<UnidadProduccion>) => api.save!<Partial<UnidadProduccion>, UnidadProduccion>(data),
        delete: (id: number) => api.delete!<UnidadProduccion>(id)
    };
}